/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroup } from './UserGroup';
import {
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
} from './UserGroup';

/**
 * 
 * @export
 * @interface FindAllUserGroups200Response
 */
export interface FindAllUserGroups200Response {
    /**
     * 
     * @type {Array<UserGroup>}
     * @memberof FindAllUserGroups200Response
     */
    data?: Array<UserGroup>;
}

/**
 * Check if a given object implements the FindAllUserGroups200Response interface.
 */
export function instanceOfFindAllUserGroups200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllUserGroups200ResponseFromJSON(json: any): FindAllUserGroups200Response {
    return FindAllUserGroups200ResponseFromJSONTyped(json, false);
}

export function FindAllUserGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUserGroups200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserGroupFromJSON)),
    };
}

export function FindAllUserGroups200ResponseToJSON(value?: FindAllUserGroups200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserGroupToJSON)),
    };
}

